import GenericDictionaryPage from "./GenericDictionaryPage";
import { getClaimProfessionalType } from "../api/claimProfessionalType";

export default function ClaimProfessionalType() {
    return (
        <GenericDictionaryPage
            tableKey="claimProfessionalType"
            fetchData={getClaimProfessionalType}
            titleKey="genericDic:claimProfessionalType"
            newButtonLabel="genericDic:claimProfessionalTypeButtonNew"
        />
    );
}
